(function () {
  // Site genelinde "/cart/add" adresine post eden HER formu yakalar (ürün kartları,
  // ürün sayfası vb.) — sayfa yenilenip sepete yönlendirmek yerine AJAX ile ekler,
  // üstte "Sepete Eklendi" bildirimi gösterir ve header'daki sepet ikonunun
  // rakamını günceller. Sepet ikonu zaten /cart adresine link olduğu için
  // ikona tıklayınca sepete gitme davranışı ayrıca dokunulmadan çalışır.

  function isCartAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  function showToast(message, isError) {
    var existing = document.querySelector('.ajax-cart-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'ajax-cart-toast' + (isError ? ' ajax-cart-toast--error' : '');
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      (isError
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v5M12 16h.01"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg>') +
      '<span></span>';
    toast.querySelector('span').textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.remove();
      }, 250);
    }, 2600);
  }

  function updateCartBubble() {
    fetch('/?section_id=cart-icon-bubble')
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = html.trim();
      })
      .catch(function () {
        /* Bildirim zaten gösterildi, ikon güncellemesi başarısız olursa sessiz geç */
      });
  }

  function handleSubmit(form, submitter) {
    var submitButton = submitter || form.querySelector('[type="submit"]');
    var originalText = submitButton ? submitButton.textContent : '';
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Ekleniyor…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function () {
        showToast('Sepete Eklendi');
        updateCartBubble();
      })
      .catch(function (err) {
        var message = (err && (err.description || err.message)) || 'Ürün sepete eklenemedi, lütfen tekrar deneyin.';
        showToast(message, true);
      })
      .finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalText;
        }
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isCartAddForm(form)) return;
      event.preventDefault();
      handleSubmit(form, event.submitter);
    },
    true
  );
})();
